import React, { useCallback, useEffect, useState } from "react";
import MdmCard from "../../components/mdmCard/MdmCard";
import "../../features/mdm/mdm.css";
import {  getMasterData } from "../../services/mdmService/mdmService";
import { DomainValue} from "../../services/mdmService/types";
import { ConfirmationPopUp } from "../../components/popup/confirmationPopUp";
import { useNavigate } from "react-router-dom";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";
import { fetchAndDownloadReport } from "../../services/reportService";
import NewMdmCardMenu from "./newMDMCardMenu";
import { useSelector } from "react-redux";
import ImportNewMdmDataModal from "./importNewMDMModal";
import { setFormConfig, setMdmCurrentEntity, updateCards } from "../../stateManagement/actions/mdmDashboard";
import { getMetaDataConfig } from "../../services/uiConfigService";
import { formConfig, initialCards } from "./mdmUtils";
import { Loader } from "../../components/loader/Loader";
function NewFlowMDM() {
  // const [loading, setLoading] = useState<boolean>(false);
  const { translate } = usePortalTranslation();
  const [showModal, setShowModal] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const cards = useSelector((state: any) => state.mdmDashboardReducer.cards);
  const selectedFormConfig = useSelector((state: any) => state.mdmDashboardReducer.formConfig);
  const [mdmData, setMdmData] = useState([]);
  const [cardsLoading, setCardsLoading] = useState(true);
  const [formConfigLoading, setFormConfigLoading] = useState(true);
  const [popoverAnchorElement, setPopoverAnchorElement] = React.useState<null | HTMLElement>(null);
  const [menuMoreOption, setMenuMoreOption] = useState<DomainValue|null>(null)
  const [confirmationModalOpened, setConfirmationModalOpened] = useState(false);
  const [downloadUrl, setDownloadUrl] = useState<string|undefined>("");
  const navigate = useNavigate();
  const open = Boolean(popoverAnchorElement)
  const changePopoverAnchorElement = (event: React.MouseEvent<HTMLElement|null>) => {
    event.stopPropagation();
    if(popoverAnchorElement===event.currentTarget){
      setPopoverAnchorElement(null);
    }
    else{
      const menuId = event.currentTarget.id;
      const findMenu:any = mdmData.find((obj:DomainValue)=> obj&&obj.id === menuId);
      if(findMenu){
        if (!Array.isArray(findMenu.menuOption)) {
          findMenu.menuOption = [];
        }
        const hasViewAndEdit = findMenu.menuOption.some(
          (option:any) => option.id === "viewsAndEdit"
        );
        if (!hasViewAndEdit) {
          findMenu.menuOption.push({
            id: "viewsAndEdit",
            label: "View and Edit",
          });
        }
        setMenuMoreOption(findMenu);
        setPopoverAnchorElement(event.currentTarget);
      }
    }
  };
  const closeMoreOptionPopover =()=>{
    setPopoverAnchorElement(null);
  }
  const mdmMenuRegistry = (event: React.MouseEvent<HTMLElement|null> )=> {
    // // 
    if(menuMoreOption !== null){
      setMdmCurrentEntity(menuMoreOption);     
        if(menuMoreOption.id === "Variable"){
          if(event.currentTarget.id === "viewsAndEdit"){
            navigate("/dashboard/mdm/division")
            return;
          }
        }   
        switch (event.currentTarget.id) {
          // case "import":
          //   mdmData.forEach((element)=>{
          //     if(element.id === menuMoreOption.id){
          //       setDownloadUrl(element.templateUrl);
          //     }
          //   });
          //   setShowModal(true)
          //   break;
          // case "viewsAndEditDivision":
          //   navigate("roleDivision")
          //   break;
          // case "logsAndReport":
          //   navigate("logs")
          //   break;
          case "viewsAndEdit":
            navigate("viewAndEdit")
            break;
          // case "masterDownload":
          //   setConfirmationModalOpened(true);
          //   break;
          // case "dataSupportDownload":
          //   navigate("dataValidationSupport");
          //   break;
          default:
            break;
        }
    }
  }
  const downloadFile = async ()=>{
    
    const url = await getMasterData(menuMoreOption?.entity);
    
    fetchAndDownloadReport(url);
  }
  useEffect(() => {
    const fetchInitialCards = async () => {
      try {
        const response = await getMetaDataConfig("clientConfig", "generic_mdm_configuration");
        if (response?.domainValues?.length > 0) {
          updateCards(response.domainValues);
        } else {
          updateCards(initialCards);
        }
      } catch (error) {
        console.error("Error fetching cards:", error);
      } finally {
        setCardsLoading(false);
      }
    };
    fetchInitialCards();
  }, []);

  useEffect(() => {
    const fetchInitialFormConfig = async () => {
      try {
        const response = await getMetaDataConfig("clientConfig", "form_configuration");
        if (response?.domainValues?.length > 0) {
          setFormConfig(response.domainValues);
        }else{
          setFormConfig(formConfig);
        }
      } catch (error) {
        console.error("Error fetching formConfig:", error);
      } finally {
        setFormConfigLoading(false);
      }
    };
    fetchInitialFormConfig();
  }, []);

  useEffect(() => {
    setMdmData(cards);
  }, [cards]);

  const loading = cardsLoading || formConfigLoading;

  if (loading) return <Loader />;
  return (
    <>
     { showErrorMessage ?<div className="mdm-error">
         <div className="mdm-card-error-msz"> Cards are not available for Now, Kindly refresh</div>
        </div> :
         <>
        <div className="mdm-body" onClick={closeMoreOptionPopover}>
          <div className="mdm-title">{translate(TranslationEnum.common_portal,"Master Data Management")}</div>
            <div className="mdm-container" >
            { mdmData.length > 0 && mdmData.map((mdmDataObject: DomainValue, colorIndex:number) => {
              const mdmDataObj = {...mdmDataObject}
              return <MdmCard colorIndex={colorIndex} key={mdmDataObj.id} mdmData={mdmDataObj} changePopoverAnchorElement={changePopoverAnchorElement}/>;
            })}
            <NewMdmCardMenu menuMoreOption={menuMoreOption} id="simple-popper" open={open} popoverAnchorElement={popoverAnchorElement} mdmMenuRegistry={mdmMenuRegistry}/>
            </div>
        </div>
        <ImportNewMdmDataModal Open={showModal} setShowModal={setShowModal} downloadUrl={downloadUrl}/>
        <>
          <ConfirmationPopUp
            message="Are you sure you want to download master data?"
            openConfirmModal={confirmationModalOpened}
            setOpenConfirmModal={setConfirmationModalOpened}
            successMethod={downloadFile}
          />
        </> 
      </> 
      }
    </>
  );
}

export default NewFlowMDM;
